import { NotificationData, NotificationsPayload, NotificationsState } from './notifications-types';

export function updateNotifications(state: NotificationsState, payload: Partial<NotificationsPayload>): NotificationsState {
  if (!payload?.notifications) {
    return state;
  }

  const notificationMap = new Map(state.notificationDataList.map((notification) => [notification.id, notification]));

  payload.notifications.forEach((notification) => {
    notificationMap.set(notification.id, notification as NotificationData);
  });

  state.notificationDataList = Array.from(notificationMap.values());

  return state;
}

export function deleteNotifications(state: NotificationsState, payload: Partial<NotificationsPayload>): NotificationsState {
  if (!payload?.notifications) {
    return state;
  }

  const notificationIdsToDelete = new Set(payload.notifications.map((n) => n.id));
  const notificationList = state.notificationDataList.filter((notification) => !notificationIdsToDelete.has(notification.id));

  state.notificationDataList = notificationList;

  return state;
}
